export default __webpack_public_path__ + "static/media/reporting_icon_white.671e3888.svg";